"use strict";
var React = require("react");

var SettingsTab = React.createClass({
    render: function() {
      return (
        <div>
          <div className="settings-header row">
            <h3>Stillingar</h3>
          </div>
          <div className="settings-body clearfix">
            <h1>Coming soon...</h1>
          </div>
        </div>
      );
    }
});


module.exports = SettingsTab;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Settings/SettingsTab.react.js